export default __webpack_public_path__ + "static/media/WheelIcon.2b07a915.png";